import React, { useState, useEffect } from "react";
import { useTooltipMode } from "../context/TooltipModeContext";
import { useTooltip } from "../context/TooltipContext";
import {ALARMAS_PS} from "../../../lib/alarmCodes"

import "./PipelineChart.css";




export default function PipelineChart({
  alarmas = true ,
  data,
  metric,
  bomba,
  tempMin = 0,
  tempMax = 20,
  pipelineLarge = false,
  fallaSensor,
  tooltip,
  setTooltip,
  cantidad_bombas,
  translate,
  userLevel
}) {
  const { mode } = useTooltipMode();
  const { tooltipIdx, setTooltipIdx } = useTooltip();
  const [localTooltipIdx, setLocalTooltipIdx] = useState(null);
  // arriba del componente o al inicio dentro de él
  const FONT_BASE = cantidad_bombas === 1 ? 18 : 25;       // tu tamaño actual 16
  const FONT_SCALE = pipelineLarge ? 3 : 2.2;       // 3x
  const FONT = FONT_BASE * FONT_SCALE;

  if (!data?.length) return '';

  // console.log('pipelineLarge',pipelineLarge)
  const user = (localStorage.getItem("username")) || '';

  // === Coordenadas del viewBox (sistema interno) ===
  const width = cantidad_bombas === 1 ? 1800 : 1200;
  const height = pipelineLarge ? ( cantidad_bombas === 1 ? 310 : 350) : ( cantidad_bombas === 1 ? 220 : 250);
  const paddingTopBottom = 28;
  const paddingLeft = 30;
  const paddingRight = 230;

  //  Calcular rangos Y
  let yMin, yMax;
  if (metric === "O2") {
    yMin = bomba.SetPoint ?? 0;
    yMax = bomba.SetPointOFF ?? 10;
    // const vals = data.map(d => d.O2).filter(v => v !== undefined );
    const vals = data.map(d => d.O2).filter(v => v !== undefined && v !== null && v !== -1 && v !== -100);

    if (vals.length) {
      const minData = Math.min(...vals);
      const maxData = Math.max(...vals);
      if (minData < yMin) yMin = minData;
      if (maxData > yMax) yMax = maxData;
    }
  } 
  else if (metric === "SO2") {
    yMin = (bomba.SetPoint ?? 0) * 10;
    yMax = (bomba.SetPointOFF ?? 10) * 10;
    // const vals = data.map(d => d.SO2).filter(v => v !== undefined);
    const vals = data.map(d => d.SO2).filter(v => v !== undefined && v !== null && v !== -100);

    if (vals.length) {
      const minData = Math.min(...vals);
      const maxData = Math.max(...vals);
      if (minData < yMin) yMin = minData;
      if (maxData > yMax) yMax = maxData;
    }
  } else {
    const values = data.map(d => d.Temp).filter(v => v !== undefined);
    if (values.length > 0) {
      const minData = Math.min(...values);
      const maxData = Math.max(...values);
      yMin = minData - Math.abs(minData) * 0.2;
      yMax = maxData + Math.abs(maxData) * 0.2;
    } else {
      yMin = tempMin;
      yMax = tempMax;
    }
  }

  // Escalas en unidades del viewBox
  const innerW = width - paddingLeft - paddingRight;
  const innerH = height - paddingTopBottom * 2;

  const xScale = (i) => (i / (data.length - 1)) * innerW + paddingLeft;
  const yScale = (v) => {
    // y=0 arriba en SVG; invertimos para que yMax esté arriba del gráfico
    return paddingTopBottom + ((yMax - v) / (yMax - yMin)) * innerH;
  };

  // Generar segmentos coloreados
  const segments = [];
  for (let i = 1; i < data.length; i++) {
    const prev = data[i - 1];
    const curr = data[i];
    const valPrev = prev[metric];
    const valCurr = curr[metric];
    // if (valPrev === undefined || valCurr === undefined) continue;
    if (
      valPrev === undefined || valPrev === null || valPrev === -1 ||valPrev === -100 ||
      valCurr === undefined || valCurr === null || valCurr === -1 ||valCurr === -100 
    ) continue;
    const color = metric === "Temp" ? "#f97316" : curr.injecting ? "#ff5370ff" : "#00ffff";
    segments.push({
      x1: xScale(i - 1),
      y1: yScale(valPrev),
      x2: xScale(i),
      y2: yScale(valCurr),
      color,
    });
  }


  const handleMouseMove = e => {
    const rect = e.currentTarget.getBoundingClientRect();
    const scaleX = width / rect.width;
    const mouseX = (e.clientX - rect.left) * scaleX;

    const ratio = (mouseX - paddingLeft) / innerW;
    const idx = Math.max(0, Math.min(data.length - 1, Math.round(ratio * (data.length - 1))));
// console.log('data', data)
    if (mode === "detailed") {
      setTooltipIdx(idx);
    } else {
      setLocalTooltipIdx(idx);
      setTooltip?.({
        idx,
        O2: data[idx]?.O2 ?? null,
        SO2: data[idx]?.SO2 ?? null,
        Temp: data[idx]?.Temp ?? null,
        TS: data[idx]?.TS ?? null,
        Mass_Flowmeter_Oxigeno: data[idx]?.Mass_Flowmeter_Oxigeno ?? null,
        Acumulador_Oxigeno: data[idx]?.Acumulador_Oxigeno ?? null,
      });
    }
  };

  const handleMouseLeave = () => {
    setTooltipIdx(null);
    setLocalTooltipIdx(null);
    setTooltip?.(null);
  };

  const activeIdx = mode === "detailed" ? tooltipIdx : localTooltipIdx;
  const ticks = getYAxisTicks(yMin, yMax, 3); // [yMin, yMid, yMax]

  // console.log("mode:", mode, "tooltip:", tooltip, "activeIdx:", activeIdx)

  return (
    <>
      {user === 'itg' && activeIdx !== null  && data[activeIdx]?.alarms?.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "11.2vh",
            left: "50%",              // CENTRA HORIZONTALMENTE
            transform: "translateX(-50%)",
            minWidth: "8.5vw",
            background: "#111827cc",
            padding: "0.3vh 0.5vw",
            borderRadius: 8,
            color: "white",
            pointerEvents: "none",
            backdropFilter: "blur(4px)",
            zIndex: 999,
            display:'flex',
            justifyContent:'center',
            flexDirection:'column'
          }}
        >
          
          {/* ALERTAS */}
            <TooltipAlarms 
              alarms={data[activeIdx].alarms}
              ALARMAS_PS={ALARMAS_PS}
              translate={translate}
            />
        </div>
      )}
      <svg
        className="pipeline-chart"
        viewBox={`0 0 ${width} ${height}`}
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet" // llena 100% del contenedor
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{opacity: fallaSensor ? 0.5 : 1, marginTop:'0.5vh'}}
      >

        {/* Marcadores de alarmas */}
        { user === 'itg' && alarmas && data.map((d, i) => {

          // console.log('d', d)
          if (!d.alarms || d.alarms.length === 0) return null;

          const x = xScale(i);

          return (
            <g key={`alarm-${i}`}>
              <line
                x1={x}
                y1={paddingTopBottom}
                x2={x}
                y2={height - paddingTopBottom}
                stroke="#ff000055"
                strokeWidth={2}
                strokeDasharray="4,4"
              />

              <circle
                cx={x}
                cy={height - paddingTopBottom + 12}
                r={8}
                fill="#ff3b3b"
                stroke="white"
                strokeWidth={2}
              />
            </g>
          );
        })}

        {/* Eje Y a la derecha */}
        <line
          x1={width - paddingRight}
          y1={paddingTopBottom}
          x2={width - paddingRight}
          y2={height - paddingTopBottom}
          stroke="#c3c3c3"
          strokeWidth={1}
        />

        {/* Líneas horizontales */}
        { mode === "detailed" && ticks.map((val, idx) => (
          <line
            key={idx}
            x1={paddingLeft}
            y1={yScale(val)}
            x2={width - paddingRight}
            y2={yScale(val)}
            stroke="#c3c3c357"
            strokeDasharray="2,2"
            strokeWidth={1}
          />
        ))}

        {/* Labels Y con ticks */}
        {ticks.map((val, idx) => {
          const yPos = yScale(val);
          return (
            <g key={idx}>
              <line
                x1={width - paddingRight}
                y1={yPos}
                x2={width - paddingRight + 20}
                y2={yPos}
                stroke="#c3c3c3"
                strokeWidth={1}
              />
              <text
                x={width - paddingRight + 30}
                y={yPos + 8}
                fontSize={FONT}  
                textAnchor="start"
                fill="#c3c3c3"
              >
                {val.toFixed(1)}
              </text>
            </g>
          );
        })}

        {/* Segmentos coloreados */}
        {segments.map((seg, idx) => (
          <line
            key={idx}
            x1={seg.x1}
            y1={seg.y1}
            x2={seg.x2}
            y2={seg.y2}
            stroke={seg.color}
            strokeWidth={5}
          />
        ))}

        {/* Tooltip */}
        {activeIdx !== null && activeIdx < data.length && (
          <>
            {/* Línea vertical */}
            <line
              x1={xScale(activeIdx)}
              y1={paddingTopBottom}
              x2={xScale(activeIdx)}
              y2={height - paddingTopBottom}
              stroke="#c3c3c3"
              strokeDasharray="6"
              strokeWidth={1}
            />

            {/* Punto */}
            <circle
              cx={xScale(activeIdx)}
              cy={yScale(data[activeIdx][metric])}
              r={9}
              fill="red"
            />

            {/* Tooltip con fondo */}
            {(() => {
              const value = data[activeIdx][metric];
              if (value === null || value === -1 || value === -100) return null;


              const alarms = data[activeIdx].alarms ?? [];

              const timestamp = data[activeIdx].TS;
              const date = new Date(timestamp);
              const timeStr = date.toLocaleTimeString("es-CL", { hour12: false }).split(".")[0];

              const paddingX = 10;
              const paddingY = 6;

              // Calcula el ancho del texto para ajustar el fondo
              const textLength = timeStr.length * (FONT * 0.6); // aproximación
              const tooltipWidth = textLength + paddingX * 2;
              const tooltipHeight = FONT + paddingY * 2;

              const isRight = xScale(activeIdx) > width / 2;
              const offsetX = isRight ? -tooltipWidth - 10 : 10;
              const offsetY = 25;

              const tooltipX = xScale(activeIdx) + offsetX;
              const tooltipY = yScale(value) + offsetY;

              return (
                <g>
                  <rect
                    x={tooltipX}
                    y={tooltipY - tooltipHeight}
                    // y={tooltipY - tooltipHeight - (alarms.length > 0 ? 25 : 0)} // Ajusta altura si hay alarmas
                    width={tooltipWidth}
                    height={tooltipHeight}
                    // height={tooltipHeight + (alarms.length > 0 ? 65 : 0)}
                    fill="#171717"
                    rx={6}
                    ry={6}
                  />
                  <text
                    x={tooltipX + paddingX}
                    y={tooltipY - tooltipHeight / 2 + FONT / 3}
                    fill="#c3c3c3"
                    fontSize={FONT}
                  >
                    {timeStr}
                  </text>

                  {/* Alarma dentro del tooltip */}
                  {/* {alarms.length > 0 && (
                    <text
                      x={tooltipX + paddingX}
                      y={tooltipY + 108}
                      fill="#ff4b4b"
                      fontSize={FONT * 0.8}
                    >
                      ⚠ {ALARMAS_PS[alarms[0]]}
                    </text>
                  )} */}
                </g>
              );
            })()}


          </>
        )}
      </svg>
    </>
  );
}

/**
 * Devuelve los ticks del eje Y
 */
export function getYAxisTicks(yMin, yMax, steps = 3) {
  const interval = (yMax - yMin) / (steps - 1);
  const ticks = [];
  for (let i = 0; i < steps; i++) ticks.push(yMin + i * interval);
  return ticks; // [yMin, yMid, yMax]
}



function TooltipAlarms({ alarms, ALARMAS_PS, translate }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!alarms || alarms.length <= 1) return;

    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % alarms.length);
    }, 1500);

    return () => clearInterval(interval);
  }, [alarms]);

  if (!alarms || alarms.length === 0) return null;

  return (
    <div style={{ fontSize: 'min(0.5vw, 1vh)', color: "#ff4b4b" }}>
      ⚠ {translate(ALARMAS_PS[alarms[current]])}
    </div>
  );
}
